import {
  addVehicle,
  editVehicle,
  fetchVehicleById,
  fetchClients,
  activeVehicle,
  inactiveVehicle
} from "@/api/financial";
import { t } from "@/lib/i18n";
import moment from 'moment'

const state = {
  all: [],
  isLoading: false,
  vehicleById: null,
  clients: []
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchVehicleById({ dispatch, commit }, id) {
    try {
      const vehicle = await fetchVehicleById(id);
      commit("setVehicleById", vehicle);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchClients({ dispatch, commit }) {
    try {
      const clients = await fetchClients();
      commit("setClients", clients);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  // async fetchFiltered({ dispatch, commit }, queriesParams) {
  //   try {
  //     const banks = await fetchFiltered(queriesParams);
  //     commit("setAll", banks);
  //   } catch (e) {
  //     dispatch("notify/error", e, { root: true });
  //   }
  // },

  async createVehicle({ dispatch, commit }, data) {
    commit("setLoading", true);
    try {
      await addVehicle(data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      if (e.message && e.message.includes("alreadyExists")) {
        message = 'Placa já cadastrada!';
      }

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async editVehicle({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await editVehicle(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      if (e.message && e.message.includes("alreadyExists")) {
        message = 'Placa já cadastrada!';
      }

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async activeVehicle({ dispatch, commit }, id) {
    commit("setLoading", true);

    try {
      await activeVehicle(id);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async inactiveVehicle({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);

    try {
      await inactiveVehicle(id, data);
      return true;
    } catch (e) {
      let message = t(e.message) || e;

      dispatch(
        "notify/error",
        { message },
        { root: true }
      );

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  clearVehicleById({ commit }) {
    commit("clearVehicleById", null);
  }
};

const mutations = {
  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.vehicleById = null;
    state.clients = []
  },

  setClients(state, clients) {
    state.clients = clients;
  },

  setVehicleById(state, vehicle) {
    state.vehicleById = {
      id: vehicle.id_veiculo_maxfrota,
      contract: vehicle.id_contrato,
      client: vehicle.id_cliente,
      installationDate: moment(vehicle.data_instalacao_veiculo_maxfrota).format('YYYY-MM-DD'),
      code: vehicle.COD,
      serie: vehicle.EQUIPMENT_SERIAL,
      description: vehicle.DESCRI,
      vehicleType: vehicle.TYPE_ID,
      chassis: vehicle.CHASSIS,
      plate: vehicle.PLATE,
      color: vehicle.COLOR,
      brand: vehicle.COMPANY,
      year: vehicle.YEAR,
      model: vehicle.MODEL,
      isActive: vehicle.DISACTIVATE == 0,
      VEI_SEN_TEMP: vehicle.VEI_SEN_TEMP,
      VEI_RFID: vehicle.VEI_RFID,
    }
  },

  clearVehicleById(state) {
    state.vehicleById = null;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
